module.exports = __webpack_public_path__ + "img/benefits-401k.f990e9fc.jpg";